import SidebarCollapseIcon from '@atlaskit/icon/core/sidebar-collapse';
import * as React from 'react';

export function SvgMenuHide() {
  return <SidebarCollapseIcon label="" testId="ads-refreshed-icon" />;
}
